import { Location, NgIf, NgTemplateOutlet, NgFor, CurrencyPipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { faAngleLeft, faFileDownload, faQuestionCircle, faRotateLeft, faSortDown, faSortUp, faSortAmountDownAlt } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import { environment } from 'src/environments/environment';
import { DatePickerControllerComponent } from '../date-picker-controller/date-picker-controller.component';
import { ReportService } from '../report.service';
import { TableControlService } from '../table-control.service';
import { FormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { LoaderService } from '../shared/services/loader.service';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip, NgbPopover, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-reports-payroll-summary',
    templateUrl: './reports-payroll-summary.component.html',
    styleUrls: ['./reports-payroll-summary.component.css'],
    imports: [NgbTooltip, FaIconComponent, DatePickerControllerComponent, ReactiveFormsModule, NgbPopover, NgIf, NgTemplateOutlet, NgFor, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgxSpinnerComponent, CurrencyPipe]
})
export class ReportsPayrollSummaryComponent implements OnInit, AfterViewInit {

  payrollForm: UntypedFormGroup;

  // Properties
  @ViewChild('datePickerController') private datePickerController: DatePickerControllerComponent;
  entries: any[] = [];
  totalRegularHours: number = 0;
  totalOvertimeHours: number = 0;
  totalGrossPay: number = 0;
  isMobile: boolean = true;
  startDate: string;
  endDate: string;
  sortOptions = [
    { label: 'Employee', value: 'u.user_last_name' },
    { label: 'Pay Rate', value: 'u.user_hourly_rate' },
  ];
  sortBy: string = 'u.user_last_name';
  sortDirection: string = 'ASC';

  // Table Controls
  tableControls: TableControlService;

   // Font Awesome Properties
   faQuestionCircle = faQuestionCircle;

  // Font Awesome Properties
  faAngleLeft = faAngleLeft;
  faFileDownload = faFileDownload;
  faSortUp = faSortUp;
  faSortDown = faSortDown;
  faRotateLeft = faRotateLeft;
  faSortAmountDownAlt = faSortAmountDownAlt;

  constructor(private reportService: ReportService,
    private formBuilder: FormBuilder,
    public location: Location,
    private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.isMobile = (window.screen.width <= 360 || window.screen.width <= 768);
    window.addEventListener('resize', () => {
      this.isMobile = (window.screen.width <= 360 || window.screen.width <= 768);
    });
    this.tableControls = new TableControlService('Reports.PayrollSummary', true, 'u.user_last_name', 'ASC');
    this.tableControls.refresh.subscribe(() => {
      this.getPayrollSummaryReport();
    });

    this.payrollForm = this.formBuilder.group({
      reqHours: [40, [Validators.required]]
    })
  }

  ngAfterViewInit(): void {
    this.tableControls.datePickerController = this.datePickerController;
  }

  // Date Changed
  dateChanged(event: { startDate: string, endDate: string, isAuto: boolean }): void {
    this.loaderService.showSpinner();
    this.startDate = event.startDate;
    this.endDate = event.endDate;
    this.tableControls.addRangeFilter('te.time_entry_start', dayjs(this.startDate).startOf('date').unix(), dayjs(this.endDate).endOf('date').unix(), event.isAuto);
  }

  // Get Payroll Summary Report
  public getPayrollSummaryReport(): void {
    let params = this.tableControls.getParams();
    params.reqHours = this.payrollForm.controls['reqHours'].value;
    if(this.isMobile) {
      params.sortBy = this.sortBy;
      params.sortDirection = this.sortDirection;
    };
    this.reportService.getPayrollSummaryReport(params).subscribe( {
      next: (reportData) => {
        this.entries = reportData.entries;
        this.totalRegularHours = reportData.totalRegularHours;
        this.totalOvertimeHours = reportData.totalOvertimeHours;
        this.totalGrossPay = reportData.totalGrossPay;
        this.loaderService.hideSpinner(700);
      },
      error: () => {
        this.loaderService.hideSpinner(700);
      }
    });
  }

  // Download Report
  downloadReport(): void {
    const searchParams = new URLSearchParams();
    searchParams.set('filter:range:te.time_entry_start', dayjs(this.startDate).unix() + ":" + dayjs(this.endDate).unix());
    const url = new URL('/api/reports/finances/payrollSummary/download?' + searchParams.toString(), environment.apiUrl);
    window.open(url.toString());
  }

  // Sorting
  sorting(column: string): void {
    if (column != this.sortBy) this.sortDirection = 'ASC';
    if (column == this.sortBy) this.sortDirection = (this.sortDirection == 'ASC') ? 'DESC' : 'ASC';
    this.sortBy = column;
    this.getPayrollSummaryReport();
  }
}
